import { render } from "./TablaCreditos.vue?vue&type=template&id=05f79600&scoped=true"
import script from "./TablaCreditos.vue?vue&type=script&lang=js"
export * from "./TablaCreditos.vue?vue&type=script&lang=js"

import "./TablaCreditos.vue?vue&type=style&index=0&id=05f79600&lang=css"
import "./TablaCreditos.vue?vue&type=style&index=1&id=05f79600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f79600"]])

export default __exports__